<template>
  <TheSpinner v-if="isTheSpinnerVisible" />
  <Toast
    position="bottom-right"
    :base-z-index="1"
  />
  <FeatureUnavailableModal />
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
  <AIModal />
</template>

<script lang="ts">
import {
  provide, defineComponent, computed, ref, onMounted, onBeforeUnmount,
} from 'vue';
import Toast from 'primevue/toast';

import { TenantAttributes } from '@/types';
import { useStore } from '@/store';
import TheSpinner from '@/components/TheSpinner.vue';
import FeatureUnavailableModal from '@/components/modals/FeatureUnavailableModal.vue';
import AIModal from '@/components/modals/AIModal.vue';
import {
  startShopVersionPoller,
  stopShopVersionPoller,
} from '@/composables/shopVersionPoller';

export default defineComponent({
  name: 'App',
  components: {
    AIModal,
    TheSpinner,
    Toast,
    FeatureUnavailableModal,
  },

  setup() {
    const tenantAttributes: TenantAttributes = {
      brandColors: null,
      logo: '',
    };
    provide('tenantAttributes', tenantAttributes);
    const store = useStore();
    const isTheSpinnerVisible = computed(() => store.state.general.isTheSpinnerVisible);

    // Intégration du widget OPIA
    onMounted(() => {
     /* const script = document.createElement('script');
      script.src = 'http://localhost:3001/widget/opia-widget.js';
      script.onload = () => {
        window.OpiaWidget.init({
          apiUrl: 'http://localhost:3001',
          position: 'right-middle',
          width: '450px',
          mode: 'push',
          contentSelector: '#app'
        });
      };
      document.head.appendChild(script);*/
      startShopVersionPoller();
    });

    onBeforeUnmount(() => {
      stopShopVersionPoller();
    });

    return {
      isTheSpinnerVisible,
    };
  },
});
</script>
